// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'

/* eslint-disable no-new */
import './assets/css/common.css'
import './assets/css/flex-layout.css'
Vue.config.productionTip = false
Vue.use(ElementUI, {
  locale
})
Vue.prototype.axios = axios
// axios.defaults.baseURL = '/api'
axios.defaults.baseURL = 'http://127.0.0.1:12303'
// Vue.prototype.cloudUrl = 'http://127.0.0.1:12302'
Vue.prototype.cloudUrl = 'http://www.genomesketchub.com:12304'
Vue.prototype.globalUrl = 'http://127.0.0.1:12303'

// const path = require('path')
router.beforeEach((to, from, next) => {
  console.log('to:', to)
  let name = 'KSSD'
  var link = null
  if (to.name === 'detail_krona') {
    link = document.querySelector('link[rel*="shortcut icon"]') || document.createElement('link')
    link.type = 'image/x-icon'
    link.rel = 'shortcut icon'
    link.href = Vue.prototype.globalUrl + '/dist/static/img/krona16.png'
    name = 'krona ' + (to.query.name || '')
  }
  if (to.name === 'detail_qiime') {
    link = document.querySelector('link[rel*="shortcut icon"]') || document.createElement('link')
    link.type = 'image/x-icon'
    link.rel = 'shortcut icon'
    link.href = Vue.prototype.globalUrl + '/dist/static/img/qiime2-rect-200.png'
    name = 'qiime ' + (to.query.name || '')
  }
  console.log('title name:', name)
  window.document.title = name
  next()
})

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js